export default __webpack_public_path__ + "static/media/thunder-background.94ad11a9.jpg";